import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { showNotification } from 'src/app/helpers/show-toast';
import { sortTable } from 'src/app/helpers/sort-table';
import { DropDown } from 'src/app/_constants/dropDown.constant';
import { Doctor } from 'src/app/_models/doctor.model';
import { AllSpecialitiesApi } from 'src/app/_services/allSpecialities.service';
import { DoctorsService } from 'src/app/_services/doctors.service';
import { environment } from 'src/environments/environment';
import { baseUrl } from 'src/environments/environment.prod';

@Component({
  selector: 'app-doctors-lisiting',
  templateUrl: './doctors-lisiting.component.html',
  styleUrls: ['./doctors-lisiting.component.scss'],
})
export class DoctorsLisitingComponent implements OnInit {
  pageTitle: string = 'Doctors';
  doctorsArray: Doctor[] = [];
  filteredDoctorsArray: Doctor[] = [];
  specialtiesArray = [];
  booleansArray = DropDown;
  doctorTypes = [];
  theadArray = [
    'EN Name',
    'AR Name',
    'Speciality',
    'Phone',
    'OS',
    'Active',
    'Online',
    'Actions',
  ];
  params = {
    specialtyId: 0,
    isOnline: 'True',
    isActive: 'True',
    isEmergency: false,
    typeId: 1,
    currentPage: 1,
    pageSize: 100,
  };
  emptyArray: boolean = false;
  searchDoctorForm: FormGroup;
  isSubmited: boolean = false;
  invertSort: boolean = false;

  constructor(
    private _DoctorsService: DoctorsService,
    private specialityService: AllSpecialitiesApi,
    public toastr: ToastrService,
    private _formBuilder: FormBuilder
  ) {}

  ngOnInit(): void {
    this.searchDoctorForm = this._formBuilder.group({
      doctorSpeciality: [0],
      doctorType: [1],
      doctorStatus: ['True'],
      doctorState: ['True'],
      doctorEmergency: [false],
    });

    this.getAllSpecialties();
    this.getAllDoctorTypes();
  }

  getAllSpecialties() {
    this.specialityService.getAllSpecialties().subscribe((res) => {
      this.specialtiesArray = res?.data?.doctorSpecilaities;
      this.specialtiesArray.unshift({ id: 0, name: 'All Specialties' });
    });
  }

  getAllDoctorTypes() {
    this._DoctorsService.getAllDoctorTypes().subscribe((res) => {
      this.doctorTypes = res?.data;
    });
  }

  onSearchDoctor() {
    this.params.specialtyId = this.searchDoctorForm.value.doctorSpeciality;
    this.params.isOnline = this.searchDoctorForm.value.doctorStatus;
    this.params.isActive = this.searchDoctorForm.value.doctorState;
    this.params.isEmergency = this.searchDoctorForm.value.doctorEmergency;
    this.params.typeId = this.searchDoctorForm.value.doctorType;

    this._DoctorsService.getAllDoctors(this.params).subscribe((res) => {
      res?.data?.items.map((doctor) => {
        doctor.imagePath = doctor.imagePath?.startsWith('http')
          ? doctor.imagePath
          : `${doctor.imagePath}`;

        this.doctorsArray.push(doctor);
      });

      this.filteredDoctorsArray = [...this.doctorsArray];

      this.emptyArray = (!this.filteredDoctorsArray) ? true : false;
    });
  }

  invertSorting() {
    this.invertSort = !this.invertSort;

    this.filteredDoctorsArray = sortTable(
      this.filteredDoctorsArray,
      'fullName',
      this.invertSort
    );
  }

  onDoctorActiveChange(event, doctor) {
    doctor.isActive = event.target.checked ? 'True' : 'False';

    this._DoctorsService.updateDoctor(null, null, doctor).subscribe((response) => {
      showNotification(
        'success',
        `${response.data.name} doctor is ${
          response.data.isActive ? 'active' : 'not active'
        }`,
        this.toastr
      );
    });
  }

  onDoctorOnlineChange(event, doctor) {
    doctor.isOnline = event.target.checked ? 'True' : 'False';

    this._DoctorsService.updateDoctor(null, null, doctor).subscribe((response) => {
      showNotification(
        'success',
        `${response.data.name} doctor is ${
          response.data.isActive ? 'active' : 'not active'
        }`,
        this.toastr
      );
    });
  }
}
